import React from 'react'
import { formatedDate } from '../../Helper/constent';

const OrderPrint = ({ orderDetails = {}, products = [], user = {}, isShow = false }) => {

    const groupedProducts = products.reduce((acc, product) => {
        if (!acc[product.category_name]) {
            acc[product.category_name] = [];
        }
        acc[product.category_name].push(product);
        return acc;
    }, {});

    return (
        <div className={`puechase-invoice-container ${!isShow && 'd-none'}`}>
            <div className={`puechaseee-invoice-container`}>
                <center className="d-flex justify-content-center align-items-center">
                    <img src={orderDetails.store_logo_url} alt="Logo" width={120} />
                </center>
                <p className='text-center my-2'>{orderDetails.store_address}</p>
                <div className="puechase-invoice-details">
                    <p><span>Customer Name:</span> <br /> {orderDetails.customer_name}</p>
                    <p><span>Exp. Date:</span> <br /> {formatedDate(orderDetails.expected_date)}</p>
                </div>
                <div className="puechase-invoice-details">
                    <p><span>Invoice Number:</span> <br /> {orderDetails.invoice_number}</p>
                    <p><span>Date:</span> <br /> {formatedDate(orderDetails.order_date)}</p>
                </div>
                <div className="puechase-invoice-details">
                    <p><span>Print by:</span> {user.user_name}</p>
                    <p><span>Status:</span> {orderDetails.order_status === 1 ? "Pending" : "Delivered"}</p>
                </div>

                {/* Product List by Category */}
                <div className="puechase-product-list">
                    <table>
                        <thead>
                            <tr>
                                <th className='text-start'>Items</th>
                                <th className='text-end'>Qty</th>
                                <th className='text-end'>Price</th>
                                <th className='text-end'>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedProducts).map(([category, items]) => (
                                <React.Fragment key={category}>
                                    {/* Category Row */}
                                    <tr className="puechase-category-row">
                                        <td colSpan="4" className="puechase-category-header">
                                            <span>{category}</span>
                                        </td>
                                    </tr>
                                    {/* Product Rows */}
                                    {items.map((product, index) => (
                                        <tr key={index}>
                                            <td className='text-start'>{product.product_name}</td>
                                            <td className='text-end'>{product.stock_qty}</td>
                                            <td className='text-end'>{product.stock_purchase_price}</td>
                                            <td className='text-end'>{product.total_amount}</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="puechase-invoice-footer">
                    <p><span>GRAND TOTAL :</span> Rs {orderDetails.grand_total_amount} /-</p>
                </div>
            </div>
        </div>
    )
}

export default OrderPrint
